<template>
  <div class="club-single">
    <div class="club-header">
      <div class="container">
        <div class="row">
          <div class="col-md-9">
            <div class="club-info">
              <div class="club-image">
                <b-img
                  class="profile-image"
                  thumbnail
                  rounded="circle"
                  fluid
                  :src="club.badge.url"
                  :alt="club.name"
                  v-if="club.badge"
                />
              </div>
              <div class="club-text">
                <span>CLUB</span>
                <h1 class="club-name">{{club.name}}</h1>
                <p>{{club.club_users_count}} membros</p>
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="club-actions">
              <b-button
                variant="link-danger"
                block
                @click.stop.prevent="leaveClub"
                v-if="club.user_is_player"
              >Sair do club</b-button>

              <b-button block v-b-modal.modalJoinTeam v-if="!club.user_is_player">Entrar no club</b-button>
              <b-modal
                v-if="!club.user_is_player"
                id="modalJoinTeam"
                title="Entrar no club"
                ref="modalJoinTeam"
                @ok="handleInscriptionOk"
                @shown="clearPassword"
              >
                <p class="my-4">Informe abaixo o código recebido do dono do clube</p>
                <form @submit.stop.prevent="handleSubmit">
                  <b-form-input type="text" placeholder="Digite o código" v-model="club_password"></b-form-input>
                </form>
              </b-modal>

              <b-button
                :to="{ name: 'ClubStats', params: { id: club.slug }}"
                variant="outline-info"
                v-if="club && club.matches && club.matches.length > 0"
              >Ranking</b-button>

              <b-button
                :to="{ name: 'ClubLobbies', params: { id: club.slug }}"
                variant="outline-info"
                v-if="club && club.matches && club.matches.length > 0"
              >Últimas Partidas</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="content-club">
            <div v-html="club.content_html"></div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="roster" v-if="club.members">
            <div class="members-list">
              <div class="member" v-for="user in club.members" :key="user.slug">
                <UserCard :user="user"></UserCard>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12" v-if="club.user_is_player">
          <b-button block v-b-modal.modalCreatePost>Postar no fórum</b-button>
          <b-modal
            id="modalCreatePost"
            title="Postar no fórum"
            ref="modalCreatePost"
            @shown="clearModalFields"
            :hide-footer="true"
            size="lg"
          >
            <form @submit.stop.prevent="handleCreateSubmit">
              <b-form-group description label="Titulo do post">
                <b-form-input
                  v-model="forum_post.title"
                  type="text"
                  maxlength="50"
                  placeholder
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group description label="Conteúdo">
                <ckeditor
                  required
                  :editor="editor"
                  v-model="forum_post.content"
                  :config="editorConfig"
                ></ckeditor>
              </b-form-group>

              <b-button type="submit" variant="primary">Criar</b-button>
            </form>
          </b-modal>

          <div class="stats-table table-responsive" v-if="forum_posts">
            <table class="table is-hoverable team1">
              <tbody v-for="category in forum_posts.categories" :key="category.id">
                <tr>
                  <td colspan="0">
                    <strong>{{category.name || 'sem categoria'}}</strong>
                  </td>
                  <td>
                    <strong>última atualização</strong>
                  </td>
                  <td>
                    <strong>respostas</strong>
                  </td>
                </tr>
                <tr v-for="forum_post in category.forum_posts" :key="forum_post.id">
                  <td class="forum-post">
                    <div>
                      <router-link
                        :to="{ name: 'ForumSingle', params: { id: forum_post.id }}"
                        class="forum-link"
                      >
                        <h4 v-html="forum_post.title"></h4>
                        <!-- <b-badge variant="light">offtopic</b-badge> -->
                      </router-link>
                      <!-- <p>This is a huge release. It contains some massive behind-the-scenes changes which will make Flarum more reliable and streamline extension development going forward. There are also a few nifty new features, and plenty of bug fixes.</p> -->
                      <p>
                        <router-link
                          :to="{ name: 'UserSingle', params: { id: forum_post.user.id }}"
                        >{{forum_post.user.nickname}}</router-link>
                      </p>
                    </div>
                  </td>
                  <td>
                    <span>{{forum_post.created_at_friendly}}</span>
                  </td>
                  <td>
                    <p class="replies">{{forum_post.forum_responses_count}} respostas</p>
                  </td>
                </tr>
                <tr v-if="forum_posts.length == 0">
                  <td colspan="3">
                    <p style="text-align: center">
                      ninguém postou ainda :(
                      <br>não tenha vergonha,
                      <router-link to="/forum/new">crie um post agora</router-link>
                    </p>
                  </td>
                </tr>
              </tbody>
              <!-- </tbody> -->
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="sass">
.clubs-single-page
  // background: #f1f1f1

  .club-header
    margin: 10px 0
    .club-info
      display: flex
      align-items: center
      .club-image
        width: 120px
        height: 120px
        img
          width: 100%
          height: 100%
      .club-text
        margin-left: 10px
        line-height: 100%
        span
          font-family: 'Oswald', monospace
          font-size: 12px
        h1
          margin: 0
        p
          margin: 0
  .club-actions
    // display: flex
    text-align: center
    .btn
      width: 100%
      display: block
      margin-bottom: 5px


  .content-club
    background: rgba(255, 255, 255, .04)
    padding: 10px
    margin: 10px 0
    border-radius: 4px

  .roster
    .members-list
      display: flex
      flex-wrap: wrap
      // justify-content: space-between
      > div 
        border-radius: 100%
        position: relative

      .kick-player
        position: absolute
        bottom: 0
        left: 0
        font-size: 12px
        padding: 2px 4px
        background: rgba(255, 33, 33, .4)
        border: 0
</style>


<script>
import PageHeader from "@/components/PageHeader";
import UserCard from "@/components/UserCard";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
export default {
  name: "ClubSingle",
  data() {
    return {
      club: { name: "", id: 0, cover: {}, badge: {}, matches: [] },
      club_password: "",
      forum_posts: [],
      forum_post: { title: "", content: "", category: "" },
      editor: ClassicEditor,
      editorData: "<p>escreva aqui seu post</p>",
      editorConfig: {
        toolbar: {
          items: ["bold", "italic", "link", "undo", "redo"]
        }
      }
    };
  },
  metaInfo() {
    return {
      title: `${this.club.name}`
    };
  },
  methods: {
    initialize() {
      this.$http.get(`clubs/${this.$route.params.id}.json`).then(response => {
        this.club = response.data;
      });

      this.$http
        .get(`clubs/${this.$route.params.id}/forum_posts.json`)
        .then(response => (this.forum_posts = response.data));
    },

    clearPassword() {
      this.club_password = "";
    },

    handleInscriptionSubmit() {
      this.handleInscriptionOk();
    },
    handleInscriptionOk() {
      this.$http
        .post(`clubs/${this.$route.params.id}/join.json`, {
          club_password: this.club_password
        })
        .then(response => {
          this.$notify({
            group: "all",
            title: "Você agora faz parte deste club :)"
          });
          this.initialize();
          this.$refs.modalInscription.hide();
        })
        .catch(error => {
          this.$refs.modalInscription.hide();
        });
    },

    leaveClub() {
      if (
        confirm(
          "Tem certeza que deseja deixar o club?\nAVISO: Essa ação não tem retorno."
        )
      ) {
        this.$http
          .get(`clubs/${this.$route.params.id}/leave.json`)
          .then(response => {
            this.$notify({
              group: "all",
              title: "Você saiu do clube"
            });
            this.initialize();
          });
      }
    },

    handleCreateSubmit() {
      this.$http
        .post(`clubs/${this.$route.params.id}/forum_posts.json`, {
          forum_post: this.forum_post
        })
        .then(response => {
          this.$notify({
            group: "all",
            title: "Post criado!"
          });
          this.$refs.modalCreatePost.hide();
          this.initialize();
        });
    },

    clearModalFields() {
      this.forum_post = { title: "", content: "", category: "" };
    }
  },
  mounted() {
    this.initialize();
  },
  watch: {
    "$route.params.id": function(id) {
      this.initialize();
    }
  },
  components: {
    PageHeader,
    UserCard
  }
};
</script>
